import type { CapabilityBinding } from '../../core/types';

/** 训练集群复用的能力块绑定。 */
export const TC_CAPABILITIES = [
  { key: 'maas-system-config', pathPrefix: '' },
  { key: 'env-vars', pathPrefix: '', options: { useCard: false, listSegment: 'commonEnv' } },
  { key: 'maas-node-groups', pathPrefix: '' },
  { key: 'container-storage', pathPrefix: '', options: { listSegment: 'trainingSharedVolumes' } },
  { key: 'maas-command-args-normal', pathPrefix: 'initCommand' },
] as const satisfies readonly CapabilityBinding[];
